<div class="wrapper">
  @if (icon()) {
    <div class="icon-container">
      <i class="icon" [class]="icon()"></i>
    </div>
  }
  <div class="message-container">
    <span class="message" [class.no-margin-top]="!icon()">
      {{ message() }}
      @if (!message()) {
        <ng-content />
      }
    </span>
  </div>
  @if (showRefreshButton() && !link()) {
    <button
      [class]="buttonStyleClass() || 'size-l refresh-button'"
      alg-button
      (click)="onRefresh($event)"
    >{{ buttonCaption() }}</button>
  }
  @if (link()) {
    <a
      class="size-l refresh-button"
      alg-button
      [routerLink]="link()"
    >{{ buttonCaption() }}</a>
  }
</div>
